import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, CircularProgress } from "@mui/material";
import { dataGridStyle } from "../Styles/VMStyles";

const MuiDatagrid = (props) => {

  const {
            rows = [],
            columns = [],
            loading = false,
            page = 0,
            pageSize = 10,
            rowCount = 0,
            paginationMode = "server",
            onPageChange,
            onPageSizeChange,
            getRowId = (row) => row.id,
        } = props;

  return (
    <Box sx={{ width: "100%", position: "relative" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={getRowId}
        loading={loading}
        page={page}
        pageSize={pageSize}
        rowCount={rowCount}
        paginationMode={paginationMode}
        pagination
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        pageSizeOptions={[10, 20, 50]}
        autoHeight
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        disableColumnMenu
        hideFooterSelectedRowCount
        rowsPerPageOptions={[ 10, 20]}
        sx={dataGridStyle}
        getRowHeight={() => 'auto'} 
        paginationModel={{ page, pageSize }}            // 👈 controlled pagination
        onPaginationModelChange={(model) => {           // 👈 arrow buttons work now
          onPageChange && onPageChange(model.page);
          onPageSizeChange && onPageSizeChange(model.pageSize);
        }}

        slots={{
          loadingOverlay: () => (
            <Box
              sx={{
                width: "100%",
                mt: 4,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CircularProgress size={24} />
            </Box>
          ),
        }}
        {...props}
      />
    </Box>
  );
};

export default MuiDatagrid;